import { CAMPAIGN_JOIN_MODES } from '../model/campaign-enrolment'
import type { CampaignJoinMode } from '../model/campaign-enrolment'

/**
 * Whether the enrolment answers say who joins.
 *
 * A rolling filter *is* the rule people join by, so it needs at least one:
 * `enrollment_mode=filter` with an empty `filter_definition` comes back 422
 * "Filter enrollment needs a filter_definition". The chip row already knows
 * that before anything is sent, and a submit that was always going to bounce
 * teaches the agent nothing — the service's refusal surfaces as the generic
 * failure toast, pointing at no field. The other two modes carry their own
 * rule: a trigger its event, manual nothing at all.
 */
export function hasCampaignJoinRule(
  join: CampaignJoinMode,
  filterDefinition: Record<string, unknown>,
): boolean {
  return (
    join !== CAMPAIGN_JOIN_MODES.filter ||
    Object.keys(filterDefinition).length > 0
  )
}
